import { BaseEvent } from "./structures";
import { BaseEventInput, BaseProjectionResult, EventProcessor, EventTypeId } from "./EventProcessor";

export class EventProcessorRegistry<
    TEventType extends EventTypeId,
    TEventInputs extends BaseEventInput,
    TLocalEvent extends BaseEvent<TEventType>,
    TProjectionResult extends BaseProjectionResult,
    TServerEvent
> {
    private processors = new Map<TEventType, EventProcessor<
        TEventType,
        TEventInputs,
        TLocalEvent,
        TProjectionResult,
        TLocalEvent,
        TServerEvent
    >>();

    public registerProcessor<
        TProcessorEventInputs extends TEventInputs,
        TProcessorLocalEvent extends TLocalEvent,
        TProcessorProjectionResult extends TProjectionResult,
        TProcessorUndoEvent extends TLocalEvent,
        TProcessorServerEvent extends TServerEvent
    >(
        processor: EventProcessor<
            TEventType,
            TProcessorEventInputs,
            TProcessorLocalEvent,
            TProcessorProjectionResult,
            TProcessorUndoEvent,
            TProcessorServerEvent
        >
    ): void {
        this.processors.set(processor.eventType, processor);
    }

    public getProcessor<
        TProcessorEventInputs extends TEventInputs,
        TProcessorLocalEvent extends TLocalEvent,
        TProcessorProjectionResult extends TProjectionResult,
        TProcessorUndoEvent extends TLocalEvent,
        TProcessorServerEvent extends TServerEvent
    >(
        eventType: TEventType
    ): EventProcessor<
        TEventType,
        TProcessorEventInputs,
        TProcessorLocalEvent,
        TProcessorProjectionResult,
        TProcessorUndoEvent,
        TProcessorServerEvent
    > | undefined {
        const processor = this.processors.get(eventType);
        return processor as EventProcessor<
            TEventType,
            TProcessorEventInputs,
            TProcessorLocalEvent,
            TProcessorProjectionResult,
            TProcessorUndoEvent,
            TProcessorServerEvent
        > | undefined;
    }
}